import { DOMAIN_SPECIFIC_CHAT_TYPES } from "@common/constants";
import { ChatType } from "@common/enums/ChatType";

/**
 * Get Param Chat Type from the given Chat Type
 */
export function getRouteParamChatType(chatType: ChatType) {
    if (!chatType || !DOMAIN_SPECIFIC_CHAT_TYPES.includes(chatType)) {
        return 'qiq';
    }

    if (chatType === ChatType.QEC) {
        return 'wfdo';
    }

    return chatType.toLowerCase();
}
